import { useState } from "react";
import { Circle, Rect, Text } from "react-konva";

const arrayColor = [
  "rgb(225,29,72)" /*text-rose-500 */,
  "rgb(79,70,229)" /*text-indigo-600 */,
  "rgb(16,185,129)" /*text-emerald-500 */,
  "rgb(202,138,4)" /*text-yellow-600 */,
  "rgb(239,68,68)" /*text-red-500 */,
  "rgb(168,162,158)" /*text-stone-400 */,
  "rgb(132 204 22)" /*text-lime-500 */,
  "black",
];

const ProblemPreviewMarking = (props) => {
  const { data, parent_width, parent_height } = props;
  const { marking_warna, marking_kordinat } = data;
  let [x, y] = marking_kordinat.split(",").map((el) => parseFloat(el));
  x = parent_width * x;
  y = parent_height * y;

  const width = 50;
  const height = 50;

  //   const handleOnDragStart = (e) => {
  //     const id = e.target.id;
  //     setTmp({ x: e.target.x(), y: e.target.y() });
  //     // console.log("DRAG ID", id);
  //   };

  //   const handleOnDragEnd = (e) => {
  //     const _x = e.target.x();
  //     const _y = e.target.y();
  //     setTmp({ x: _x, y: _y });
  //     const _newX = parseFloat((_x / parent_width).toFixed(4));
  //     const _newY = parseFloat((_y / parent_height).toFixed(4));
  //     const _newMarkingKordinat = `${_newX},${_newY}`;
  //     onChangeKordinat(type, data.id, _newMarkingKordinat);
  //   };

  //   const handleOnDragMove = (e) => {
  //     setTmp({ x: e.target.x(), y: e.target.y() });
  //   };

  return (
    <>
      <Circle
        x={x}
        y={y}
        width={width}
        height={height}
        // draggable
        stroke={arrayColor[0]}
        strokeWidth={3}
        // onDragStart={handleOnDragStart}
        // onDragEnd={handleOnDragEnd}
        // onDragMove={handleOnDragMove}
      />
      {/* <Text
        x={tmp.x - 4}
        y={tmp.y + 10}
        text={index.toString()}
        fontSize={14}
        fontStyle={"bold"}
        fill={arrayColor[0]}
      /> */}
    </>
  );
};

export default ProblemPreviewMarking;
